import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ca8caf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm-aside" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "lights" }, null, -1))
const _hoisted_3 = { class: "sidebar-nav" }
const _hoisted_4 = { class: "sidebar-links mb-1" }
const _hoisted_5 = { class: "sidebar-dropdown py-1 px-3 d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-center",
  style: {"width":"16px"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down text-white" })
], -1))
const _hoisted_7 = ["href", "aria-controls"]
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "nav flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsideLinkComponent = _resolveComponent("AsideLinkComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("a", {
                href: `#asideCollapse_${index}`,
                class: "m-0 ms-2 sidebar-category text-white w-100",
                "data-bs-toggle": "collapse",
                role: "button",
                "aria-expanded": "false",
                "aria-controls": `#asideCollapse_${index}`
              }, _toDisplayString(category.title), 9, _hoisted_7)
            ]),
            _createElementVNode("div", {
              class: "collapse",
              id: `asideCollapse_${index}`
            }, [
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.links, (link, linkIndex) => {
                  return (_openBlock(), _createBlock(_component_AsideLinkComponent, {
                    key: linkIndex,
                    title: link.title,
                    obj: link.obj
                  }, null, 8, ["title", "obj"]))
                }), 128))
              ])
            ], 8, _hoisted_8)
          ]))
        }), 128))
      ])
    ])
  ]))
}